const axios = require('axios');

const HOST = process.env.REACT_APP_API;

export function getAPIUrl() {
    return HOST;
}
const http = axios.create({
    baseURL: HOST,
    withCredentials: true
});

http.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401 &&  window.location.pathname !== '/login') {
            window.location.href = '/login';
        } else {
            return Promise.reject(error);
        }
    }
);

export function get(url) {
    return http({
        url: url,
    }).then(function (res) {
        return res.data;
    });
}
export function getFiles(url){
    return http({
        url: url,
        method: 'GET',
        responseType: 'blob'
    }).then(function (res) {
        let fileName = res.config.url.substring(res.config.url.lastIndexOf('/') + 1);
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.zip');
        document.body.appendChild(link);
        link.click();
        return res.data;
    });
}

export function post(url, data) {
    return http.post(HOST + url, data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}


export default http;


export function objectToFormData (obj, form, namespace) {
    let fd = form || new FormData();
    let formKey;
    for (let property in obj) {
        if(obj.hasOwnProperty(property) && obj[property]) {
            if (namespace) {
                formKey = namespace + '[' + property + ']';
            } else {
                formKey = property;
            }
            // if the property is an object, but not a File, use recursivity.
            if (obj[property] instanceof Date) {
                fd.append(formKey, JSON.stringify(obj[property]));
            } else if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
                objectToFormData(obj[property], fd, formKey);
            } else { // if it's a string or a File object
                fd.append(formKey, obj[property]);
            }
        }
    }
    return fd;
}
